import { render, staticRenderFns } from "./sterling-bars-diversity.vue?vue&type=template&id=d4663e48&"
import script from "./sterling-bars-diversity.vue?vue&type=script&lang=js&"
export * from "./sterling-bars-diversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports